<!-- <template>
  <v-fade-transition mode="out-in">
    <router-view v-if="render" />
    <loading-screen v-else />
  </v-fade-transition>
</template>

<script>
import axios from 'axios';
export default {
  name: "App",
  components: {
    "loading-screen": () => import("./views/LoadingView.vue"),
  },
  created() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("token"); 
    if (token) {
          localStorage.setItem("token", token);
          location.replace("/");
          this.$router.push('/dashboard');
        }

  },
  data: () => ({
    render: false,
    data: null,
  }),
  methods: {
    getUser() {
      if (localStorage.getItem("token")) {
        // if(this.$store.state.user){
          this.render = false;

          axios
          .get(process.env.VUE_APP_BASE_URL + "/user/find_user/" + this.$store.state.user.id)
          .then((res) => {
            if (res.status == 200) {

              if (res.data.data.token) {
                localStorage.setItem("token", res.data.token);
                this.data = res.data;
                if(this.data.roleID){
                this.$store.dispatch("setUser", res.data.data);
                // this.$store.dispatch("setModule", res.data.data.module)
                if(this.$route.path == "/"){
                  this.$router.push("/" + this.data.BaseUrl + "/dashboard");
                  setTimeout(() => {
                    this.$router.go(0)
                  }, 0);
                }
                }
              }
              else{
                localStorage.clear();
                this.$router.push('/');
              }
              setTimeout(() => {
              this.render = true;
              }, 1000);

              
            }
          });

          this.axiosCall("/find_user", "GET")
          .then((res) => {
            if (res.data.data.token) {
              localStorage.setItem("token", res.data.token);
              this.data = res.data;
              if(this.data.roleID){
              this.$store.dispatch("setUser", res.data.data);
              // this.$store.dispatch("setModule", res.data.data.module)
              if(this.$route.path == "/"){
                this.$router.push("/" + this.data.BaseUrl + "/dashboard");
                setTimeout(() => {
                  this.$router.go(0)
                }, 0);
              }
              }
            }
            else{
              localStorage.clear();
              this.$router.push('/');
            }
            setTimeout(() => {
            this.render = true;
            }, 1000);

          })
          .catch((error) => {
            console.log(error);
            localStorage.clear();
            this.$router.push('/');
            setTimeout(() => {
            this.render = true;
            }, 1000);
          });
        // }
      } else {
        this.render = true;
        localStorage.clear();
        this.$router.replace("/", () => {});
      }
    },
  },
};
</script> -->
<template>
  <div>
    <router-view v-if="render"/>
  </div>
</template>

<script>
import { socket, connect } from "@/socket";
import { toast } from "vue3-toastify";
import pingSound from "@/assets/audio/ping_sound.mp3";
import { h } from "vue";
import axios from "axios";

export default {
  data() {
    return {
      userId: null,
      audio: null,
      audioUnlocked: false,
      render: false,
    };
  },

  mounted() {
     this.$router.isReady().then(() => {
      this.getUser();
    });
    // Create reusable audio instance
    this.audio = new Audio(pingSound);

    // Unlock audio after first user interaction (browser policy)
    window.addEventListener(
      "click",
      () => {
        this.audioUnlocked = true;
      },
      { once: true }
    );

    // Get user from store
    const storedUserId = this.$store?.state?.user?.id;

    if (storedUserId) {
      this.userId = storedUserId;

      // Connect socket
      connect(this.userId);

      // Prevent duplicate listeners
      socket.off("ping");
      socket.off("connect");
      socket.off("disconnect");

      // Global listener for pings
      socket.on("ping", (data) => {
        toast.success(
          () =>
            h(
              "div",
              {
                class:
                  "flex items-start gap-3 p-1",
              },
              [
                // icon indicator
                h(
                  "div",
                  {
                    class:
                      "w-2 h-2 mt-2 rounded-full bg-green-500 flex-shrink-0",
                  }
                ),

                // content
                h("div", { class: "flex flex-col gap-2 flex-1" }, [
                  // title/message
                  h(
                    "div",
                    {
                      class:
                        "text-sm font-medium text-gray-800 leading-snug",
                    },
                    data.message
                  ),

                  // action button row
                  h(
                    "div",
                    { class: "flex items-center justify-start" },
                    [
                      h(
                        "button",
                        {
                          class:
                            "inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-green-600 rounded-md shadow-sm hover:bg-green-700 active:scale-[0.98] transition-all duration-150",
                          onClick: (e) => {
                            e.stopPropagation();

                            if (!data.route) return;

                            if (data.route.name) {
                              this.$router.push({
                                name: data.route.name,
                                query: data.route.query || {},
                                params: data.route.params || {},
                              });
                            }
                          },
                        },
                        "View details"
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          {
            autoClose: 15000,
            closeOnClick: false,
            closeButton: true,
            hideProgressBar: false,
            position: "top-right",
            pauseOnHover: true,
            draggable: false,
            className:
              "shadow-lg border border-gray-100 rounded-lg bg-white",
          }
        );

        this.playPingSound();
      });

      // Handle reconnect automatically
      socket.on("connect", () => {
        console.log("Socket connected:", socket.id);

        if (this.userId) {
          socket.emit("join", this.userId);
          console.log("Re-joined room for user:", this.userId);
        }
      });

      // Optional: handle disconnect
      socket.on("disconnect", (reason) => {
        console.warn("Socket disconnected:", reason);
      });
    }
  },
  created() {
  const urlParams = new URLSearchParams(window.location.search);

    const urlToken = urlParams.get("token");
    const urlUserId = urlParams.get("user_id");

    const localToken = localStorage.getItem("token");

    if (urlToken) {
      if (!localToken || urlToken === localToken) {
        localStorage.setItem("token", urlToken);

        if (urlUserId) {
          localStorage.setItem("user_id", urlUserId);
        }

        // remove query from URL
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      } else {
        localStorage.clear();
        this.$router.replace("/");
        return;
      }
    }
  },
  methods: {
     getUser() {
  const localToken = localStorage.getItem("token");

  if (!localToken) {
    this.render = true;
    localStorage.clear();
    this.$router.replace("/");
    return;
  }

  this.render = false;
  console.log("TOKEN SENT TO AUTH ME:", localToken);

  axios
    .get(process.env.VUE_APP_BASE_URL + "/auth/me", {
      headers: {
        Authorization: `Bearer ${localToken}`,
      },
    })
    .then((res) => {
      const user = res.data.data;

      this.$store.dispatch("setUser", user);
      localStorage.setItem("user_id", user.id);
      this.$store.commit('UPDATE_USER',user);

      const publicPages = ["/", "/login"];

      if (publicPages.includes(this.$route.path)) {
        this.$router.replace("/dashboard");
      }
    })
    .catch((err) => {
      console.log(err);
      localStorage.clear();
      this.$router.replace("/");
    })
    .finally(() => {
      this.render = true;
    });
},
    playPingSound() {
      if (!this.audioUnlocked || !this.audio) return;

      try {
        this.audio.currentTime = 0;
        this.audio.play().catch(() => {});
      } catch (error) {
        console.warn("Audio play failed:", error);
      }
    },
  },
};
</script>

<style></style>

